<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="query['lot.no']" placeholder="business.label.lot" @clear="refresh()" @keydown.native.enter="refresh()"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh()"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="250"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.no" title="business.label.lot" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="200"/>
        <vxe-column field="lot.producingArea" title="business.label.producingArea" width="100"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
        <vxe-column field="detail.receivingman" title="business.label.receiver" width="150"/>
        <vxe-column field="detail.invoiceQuantity" title="business.label.invoiceQuantity" width="100"/>
        <vxe-column field="detail.receivedQuantity" title="business.label.receivedQuantity" width="100"/>
        <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="100"/>
        <vxe-column field="detail.rejectedQuantity" title="business.label.rejectedQuantity" width="100"/>
        <vxe-column field="detail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="100"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button :disabled="!row.command.commandGroup" content="button.printShelfLabel" icon="vxe-icon-print" status="warning" @click.stop="printData(row)"/>
            <vxe-button :disabled="row.detail.rejectedQuantity===0" content="button.printRejectLabel" icon="vxe-icon-print" status="warning" @click.stop="printRefusing(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import { getEnums, getWarehouse } from '@/utils/util'
import { DeviceHandler } from '@/deviceHelper'
import { AsnOrder } from '@/api/dto/order/AsnOrder'

export default {
  name: 'ReceiptPrintDetail',
  data() {
    return {
      loading: false,
      warehouse: getWarehouse(),
      data: [],
      order: new AsnOrder(),
      query: {
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      },
      storageEnvironments: [],
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  created() {
    getEnums('StorageEnvironment').then(result => {
      this.storageEnvironments = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.query,
        'order.id': this.order.id
      }
      findAll('receivingTagFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(order) {
      if (order) this.order = order
      this.page = 1
      this.fetch()
    },
    reset() {
      this.args = {
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      }
      this.refresh()
    },
    clear() {
      this.data = []
    },
    printData(row) {
      const body = {
        'query.no': 'receivingCheckPrint',
        sql: null,
        args: {
          commandGroup: row.command.commandGroup
        }
      }
      post(api.adminQuery, {}, body).then(res => {
        if (res.result.length > 0) {
          const Dt = []
          res.result.map(data => {
            data.zhxs = '入(' + parseInt(data.zhjs).toFixed(1) + '箱)'
            data.spmcgg = data.spmc + ' / ' + data.gg
            data.phxq = data.ph + ' / ' + data.xq
            data.sldw = '数量：' + data.sl + '(' + data.dw + ')'
            data.qyxx = data.qy + ' / ' + data.lc + data.zs + ' / ' + data.spbh
            data.dhrq = data.asnNo + ' / ' + data.scrq
            data.bdm = data.pzwh + '箱数量：' + parseInt(data.bzs).toFixed(1) + ' / ' + data.fdsx
            Dt.push(data)
          })
          if (Dt.length > 0) {
            const printList = []
            printList.push(
              {
                'PLAN_CODE': '080027',
                'WH_ID': this.warehouse.id,
                'DATA': Dt
              }
            )
            DeviceHandler.printWithDataList(printList, (q, res) => {
              post(api.receivingReceiverPrintUpdate, {}, { commandGroup: row.command.commandGroup })
            })
          }
        } else {
          this.$message.warning('无数据可打印')
        }
      })
    },
    printRefusing(row) {
      if (!row.rejectedReason.id) {
        this.$message.warning(this.$t('business.label.rejectedReason') + this.$t('message.cannotBeEmpty'))
        return
      }
      const printList = [
        {
          'PLAN_CODE': '080092',
          'WH_ID': this.warehouse.id,
          'DATA': [
            {
              zhxs: row.detail.rejectedQuantity / row.pack.factor,//折合箱数
              spmc: row.item.name,//产品名称
              gg: row.pack.specification,//规格
              cd: row.lot.producingArea,//产地
              ph: row.lot.no,//批号
              xq: row.lot.validUntil,//效期
              sl: row.detail.rejectedQuantity,//数量
              dw: row.pack.uom,//单位
              spbh: row.item.no,//商品编号
              sccs: row.lot.manufacturer,//生产厂商
              asnh: row.order.no,//asn单号
              scrq: row.lot.productionDate,//生产日期
              tm: row.item.barcodes,//条码
              pzwh: row.lot.approvalNo,//批准文号
              xsl: row.pack.factor,//箱数量
              cctj: this.storageEnvironments.find(item => item.value === row.item.storageEnvironment).label,//存储条件
              jssj: new Date().toLocaleString(),//拒收时间
              jsyy: row.rejectedReason.name,//拒收原因
              gys: row.supplier.name,//供应商
              shy: this.operator.name//收货员
            }
          ]
        }
      ]
      DeviceHandler.printWithDataList(printList, (item, res) => {
        if (res.hasOwnProperty('msg')) {

        }
      })
    }
  }
}
</script>